<template>
  <CardPrimary
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.card"
  >
    <div :style="style.headerContainer">
      <HeaderMediumPrimary
        :truncate="true"
        :style="style.header"
      >
        {{ tenant.name }}
      </HeaderMediumPrimary>
      <TextRegular
        v-if="tenant.description"
        :truncate="true"
        :style="style.description"
      >
        {{ tenant.description }}
      </TextRegular>
    </div>
    <div :style="style.center">
      <div :style="style.images">
        <UserImagePrimary
          v-for="(admin, index) in admins"
          :key="index"
          :disabled="true"
          :size="styleVariable.image.size"
          :tenantUser="admin"
        />
      </div>
      <TextRegular :style="style.text">
        {{ textUsersSize }}
      </TextRegular>
    </div>
    <div :style="style.footer">
      <template v-if="action === 'select'">
        <ButtonPrimary @click="$emit('select', tenant)">
          Select
        </ButtonPrimary>
      </template>
      <template v-if="action === 'join'">
        <ButtonSecondary
          @click="$emit('decline-invitation', invitationCode)"
          :style="style.button"
        >
          Decline
        </ButtonSecondary>
        <ButtonPrimary
          @click="$emit('accept-invitation', invitationCode)"
          :style="style.button"
        >
          Accept
        </ButtonPrimary>
      </template>
    </div>
  </CardPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import ButtonSecondary from '@modules/v2/button/button-secondary'
  import CardPrimary from '@modules/v2/card/card-primary'
  import HeaderMediumPrimary from '@modules/v2/header/header-medium-primary'
  import TextRegular from '@modules/v2/text/text-regular'
  import UserImagePrimary from '@modules/v2/image/user-image-primary'
  import { Layout } from '@js/styles'

  export default {
    name: 'CardSelectTenant',
    inheritAttrs: false,
    components: {
      ButtonPrimary,
      ButtonSecondary,
      CardPrimary,
      HeaderMediumPrimary,
      TextRegular,
      UserImagePrimary,
    },
    props: {
      action: {
        type: String,
        required: false,
        default: 'select',
      },
      invitationCode: {
        type: String,
        required: false,
        default: '',
      },
      tenant: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        adminsSizeMax: 3,
        styleVariable: {
          image: {
            size: Layout.space.lg,
          },
        },
        style: {
          button: {
            padding: `0 ${Layout.space.xs}`,
          },
          card: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '176px',
            justifyContent: 'space-between',
            padding: Layout.space.md,
            textAlign: 'center',
            width: '100%',
          },
          center: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          },
          description: {
            justifyContent: 'center',
            margin: `${Layout.space.xs} 0 0 0`,
          },
          footer: {
            alignItems: 'flex-end',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          },
          header: {
            justifyContent: 'center',
          },
          headerContainer: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            width: '100%',
          },
          images: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
            margin: `0 ${Layout.space.xs} 0 0`,
          },
          text: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-start',
            margin: `0 0 0 ${Layout.space.xs}`,
          },
        },
      };
    },
    computed: {
      adminsWithImage: function () {
        return this.tenant.admins.filter(elem => elem?.user?.image);
      },
      adminsWithoutImage: function () {
        return this.tenant.admins.filter(elem => !elem?.user?.image);
      },
      admins: function () {
        return this.adminsWithImage.concat(this.adminsWithoutImage).slice(
          0, this.adminsSizeMax);
      },
      textUsersSize: function () {
        const size = this.tenant.tenantUserCount;
        return `${ size } user${ size > 1 ? 's' : '' }`;
      },
    },
  };
</script>
